
export const defaultFilterRoles = () => {
   return {
      search: '',
      state: [1],
      perPage: 10,
      page: 1,
      sortBy: 'id',
      sort: 'DESC'
   }
}


export const defaultFilterPermissions = () => {
   return {
      assigned: false,
      search: '',
      perPage: 10,
      page: 1,
      sortBy: 'id',
      sort: 'DESC'
   }
}

export const defaultSelectedRol = () => {
   return {
      id: null,
      acl_roles_id: null,
      rol: '',
      codigo: '',
      descripcion: '',
      activo: null
     }
}

export default {
   roles: [],
   selectedRol: defaultSelectedRol(),
   filtersPermissions: defaultFilterPermissions(),
   permissions: [],
   filterRoles: defaultFilterRoles(),
   view: 1
}